import { Routes } from '@angular/router';
import { HomeComponent } from './home';
import { AboutComponent } from './about';
import { NoContentComponent } from './no-content';

import { DataResolver } from './app.resolver';
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {ServantListHomeComponent} from "./servantListHome/servantListHome.component";
import {XBodyComponent} from "./xBodyComponent/xBody.component";
import {VideoMeetingComponent} from "./video-meeting/videoMeeting.component";
import {WedomeetVideoComponent} from "./wedomeet-video/wedomeet-video.component";
import {WidgetPageComponent} from "./widget-page/widget-page.component";
import {ComplementaryInformationComponent} from "./component/complementary-information/complementaryInformation.component";
import {InvoiceInfoDetailComponent} from "./invoice-info-detail/invoice-info-detail.component";
import {TestServicesComponent} from "./component/test-services/test-services.component";
import {TestReturnUrlComponent} from "./component/test-services/test-return-url.component";


export const ROUTES:Routes = [
  {path: '', component: HomeComponent},
  {path: 'home', component: HomeComponent},
  {path: 'home/:clearCache', component: HomeComponent},
  {path: 'about', component: AboutComponent},
  {path: 'testServices', component: TestServicesComponent},
  {path: 'testReturnUrl', component: TestReturnUrlComponent},
  {path: 'servantHome', component: ServantListHomeComponent},
   // {path: 'xBody', component: XBodyComponent},
  {path: 'reset-password', component: ResetPasswordComponent},
  //{path: 'detail', loadChildren: './+detail#DetailModule'},
  {path: 'book', loadChildren: './+book#BookModule'},
  {path: 'serviceitemcalendar/:id', loadChildren: './+book#BookModule'},
  {path: 'booked', loadChildren: './+orderbag#OrderBagModule'},
  {path: 'complimentartyInformation', component: ComplementaryInformationComponent, canActivate: [false]},
  {path: 'vm/:reserveId', component: VideoMeetingComponent},
  {path: 'wdo/:reserveId/:participantType', component: WedomeetVideoComponent},
  {path: 'widget', component: WidgetPageComponent},
  {path: 'widget/:serviceId', component: WidgetPageComponent},
  {path: 'companyProfile/:companyKeyUrl', component: HomeComponent},
  {path: 'companyProfileParent/:companyKeyUrl', component: HomeComponent},
  {path: 'companyProfileParentLevel1/:companyKeyUrl', component: HomeComponent},
  {path: 'manager', component: HomeComponent},
  {path: 'manager/status', component: HomeComponent},
  {path: 'invoiceInfoDetail/:invoiceInfoId', component: InvoiceInfoDetailComponent},

  {path: '**', component: NoContentComponent},

];



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.routes.ts